import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Sign_in_interface, Sign_up_interface, package_interface } from "src/core/interfaces/auth.interface";
import { environment } from "src/environments/environment";







@Injectable({ providedIn: 'root' })
export class AuthService
{


    constructor(
        private http : HttpClient
    ){}



    get_counties()
    {

        return this.http.get(`${environment.api_url}/dropdowns/countries`);

    }


    get_packages()
    {

        return this.http.get(`${environment.api_url}/userPackages/getPackage`);

    }


    get_all_packages()
    {

        return this.http.get(`${environment.api_url}/packages/index`);

    }


    


    
    get_payment_methods()
    {

        return this.http.get(`${environment.api_url}/PaymentTypes/index`);

    }


    get_user_packages()
    {

        return this.http.get(`${environment.api_url}/userPackages/getPackage`);

    }


    get_user_tickets()
    {

        return this.http.get(`${environment.api_url}/tickets/mytickets`);

    }

    sign_up(form_data : Sign_up_interface)
    {

        return this.http.post(`${environment.api_url}/register` , form_data);

    }

    sign_in(form_data : Sign_in_interface)
    {

        return this.http.post(`${environment.api_url}/login` , form_data);

    }


    create_package(form_data : any)
    {

        return this.http.post(`${environment.api_url}/userPackages/addPackage` , form_data);

    }

    
    open_ticket(form_data : any)
    {

        return this.http.post(`${environment.api_url}/tickets/addTicket` , form_data);

    }

}